import SelectBox from '../components/SelectBox';
import SelectList from '../components/SelectList';

export default class Hero {
  constructor(element) {
    this.element = element;
    this.init();
    this.ready();
  }

  init() {
    const node = this.element.querySelector('.node-home-hero .node-inner');
    if (node && !node.select) {
      node.select = new SelectList(node, {
        placeholder: 'I Want To...',
        label: 'I Want To...',
        numerator: 1,
        after: true,
      });
      node.select = new SelectBox(node, {
        placeholder: 'I Want To...',
        remove: true,
      });
    }
  }

  ready() {
    this.element.classList.add('ready');
  }
}
